import {AttachmentsAdapter} from '@shared/components/view-files/utilities/adapter/attachment-adapter';
import {GenericAttachedFile, ItemActions} from '@shared/components/view-files/models/attachments-interface';
import {Utilities} from '@shared/utilities/utilities.model';
import {BlobTypes} from '@shared/models/attached-file.model';
import {AuthorityAttachment} from '../models/attachment.model';
import { Utilities as U } from '@shared/utilities/utilities.model';
import { AuthorityTemporaryAttachmentsDTO } from '../models/authority-temporary-attachments.dto';
import { GenericViewAttachmentPreviewDialogComponent } from '@app/shared/components/view-files/components/generic-view-attachment-preview-dialog/generic-view-attachment-preview-dialog.component';
import { TranslateContext } from '@app/shared/pipes/translate.pipe';
import { MatDialog } from '@angular/material';
import { logger } from '@app/shared/utilities/logger.model';


// •	Job 0175 - GH055HV: allegati 2 file corrotti (1 pdf, 1 png)
// const working_attachment_list__mock: any = require('@mock/authority/carglass/detail/get_working_attachment__v4.json');
// •	Job 0176 - GG303JK: allegati 2 file NON corrotti (1 pdf, 1 png)
// const working_attachment_list__mock: any = require('@mock/authority/carglass/detail/get_working_attachment__v5.json');
// •	Job 0177 - GR346XA: allegati 4 i file: 2 corrotti e 2 NON (Corrotti: 1 pdf, 1 png. NON corrotti: 1 pdf, 1 png)
// const working_attachment_list__mock: any = require('@mock/authority/carglass/detail/get_working_attachment__v6.json');
export class AuthorityAttachmentsFactory {

	/**
	 * costruisce il mock per gli allegati authority
	 * (sembrerebbe che ci siano diversi tipi di allegati...)
	 * 
	 * @param {string} title
	 * @param {MatDialog} dialog
	 * @param {AuthorityTemporaryAttachmentsDTO} dto (facoltativo - se non viene passato usa il mock interno)
	 * @returns {AuthorityAttachmentType}
	 */
	static createAdapter<T extends AuthorityAttachmentsAdapter>(adapterClass: {new(...args : any[]): T ;}, title: string, dialog: MatDialog, dto?: AuthorityTemporaryAttachmentsDTO): T {

		if (U.isEmpty(dto)) {

			// MOCK
			// dto = working_attachment_list__mock;
			// throw new Error('Gli allegati non sono disponibili al momento. Contattare l\'assistenza.');
			throw new Error('Allegati non forniti dal fornitore cristalli. Contattare l\'assistenza');
		}

		const attachmentActions: ItemActions[] = [{
			icon: 'amd-icon--circle-info-16x16',
			class: 'amd-generic-view__cta--alone',
			action: (file: GenericAttachedFile) => filePreView(file)
		}];

		// TODO
		// andrebbe messa in un file di utility
		// nel progetto viene richiamata 15 volte
		const filePreView = (item: GenericAttachedFile): void => {
			dialog.open(GenericViewAttachmentPreviewDialogComponent, {
				height: 'auto',
				width: '680px',
				disableClose: true,
				data: {
					file: item,
					translateContext: TranslateContext.AUTHORITY,
					labelTitle: 'Descrizione'
				}
			});
		};

		dto.data = !U.isEmpty(dto.data) ? dto.data.map((x: any) => new AuthorityAttachment(x)) : [];
		return new adapterClass(dto, attachmentActions, true, title);
	}
}

export class AuthorityAttachmentsAdapter extends AttachmentsAdapter<AuthorityAttachment> {
	actions: ItemActions[];

	constructor(attachments: AuthorityAttachment[], actions: ItemActions[], canAdd: boolean, title: string) {
		super();
		this.actions = actions;
		this.createAttachmentsBlock(title, canAdd, true, attachments);
	}

	createAttachedFile(moduleSpecificAttachment: AuthorityAttachment): GenericAttachedFile {
		return {
			file_manager_id: moduleSpecificAttachment.uuid,
			thumbnail_id: moduleSpecificAttachment.thumbnailId,
			file_manager_name: moduleSpecificAttachment.fileName,
			blob_name: moduleSpecificAttachment.blobName,
			blob_size: +moduleSpecificAttachment.fileSize,
			mime_type: moduleSpecificAttachment.mimeType,
			description: moduleSpecificAttachment.description,
			created_at: moduleSpecificAttachment.createdAt,
			hidden: false,
			validate: false,
			user: null,
			user_name: `${ !!moduleSpecificAttachment.userFirstName ? moduleSpecificAttachment.userFirstName: ''} ${!!moduleSpecificAttachment.userLastName ? moduleSpecificAttachment.userLastName : ''}`,
			actions: this.setCustomActions(),
			checked: false,
			canCheck: true,
			label: this.getAttachmentLabel(moduleSpecificAttachment)
		};
	}

	setCustomActions(): ItemActions[] {
		const customActions: ItemActions[] = [];
		this.actions.forEach(action => {
			const item: ItemActions = Object.create(action);
			customActions.push(item);
		});
		if (!Utilities.isVoid(customActions[1])) {
			customActions[1].icon = 'amd-icon--eye-16x16';
		}
		return customActions;
	}

	private getAttachmentLabel(attachment: AuthorityAttachment): string {
		return attachment.blobType === BlobTypes.ACCEPTANCE_REPORT || attachment.blobType === BlobTypes.REDELIVERY_DOCUMENT ? attachment.blobType : attachment.description;
	}

}


/*
 *  Al momento è solo per Authority
 *
 *  Questa classe rappresenta gli allegati temporanei di una pratica
 *  che ancora non sono stati associati alla pratica in sé
 *  e sono in attesa del batch che compie l'associazione.
 * 
 *  L'API che usa questa classe viene chiamata solo quando la pratica non ha allegati,
 *  e va a controllare se sono in attesa di associazione.
 * 
 *  Il meccanismo serve per associare al volo, quando un operatore apre la pratica, ed evitare il batch.
 * 
 *  PS: è collegata direttamente alla classe AuthorityAttachmentsAdapter
 *      ci sarebbero problemi per gli altri moduli
 *
 */ 
export class AuthorityTemporaryAttachmentsAdapter extends AuthorityAttachmentsAdapter {

  warnings : AuthorityTemporaryAttachmentsWarningModel[] = [];
  errors   : AuthorityTemporaryAttachmentsErrorModel[]   = [];
	actions  : ItemActions[] = [];

	constructor(
		dto			: AuthorityTemporaryAttachmentsDTO,
		actions	: ItemActions[], 
		canAdd	: boolean, 
		title		: string
	) {

		super(dto.data, actions, canAdd, title);
		
		if (U.isEmpty(dto)) {
			return;
		}

		this.warnings = dto.warnings.map(x => new AuthorityTemporaryAttachmentsWarningModel(x));
		this.errors   = dto.errors.map(x => new AuthorityTemporaryAttachmentsErrorModel(x));
	}
};

class AuthorityTemporaryAttachmentsMessageModel {
	externalRequestId : number;
	id                : string = '';
	createdAt         : string = '';
	message           : string = '';

	constructor(dto?: any) {
	
		if (U.isEmpty(dto)) {
			return;
		}

		this.externalRequestId = dto.external_request_id
		this.id                = dto.id
		this.createdAt         = dto.created_at
		this.message           = dto.message
	}

	getMessage(): string {
		return this.message;
	}
};

export class AuthorityTemporaryAttachmentsWarningModel extends AuthorityTemporaryAttachmentsMessageModel {

	constructor(dto?: any) {

		super(dto);
	
		if (U.isEmpty(dto)) {
			return;
		}
	}
	
	/**
	 * Ritorna il messaggio formattato
	 * 
	 * Al momento questa implementazione non supporta il multilanguage
	 * Bisognerebbe implementare una printf - guardare MessageManagerUtilities.getMessage() da esempio
	 * 
	 * @returns {string}
	 */
	getMessage(): string {
		// warning → Request ('%d') is empty or have empty attachments data
		return `La richiesta ${this.externalRequestId} è vuota o contiene dati allegati vuoti.`;
		// return this.message;
	}
}

export class AuthorityTemporaryAttachmentsErrorModel extends AuthorityTemporaryAttachmentsMessageModel {
	requestNumber        : number;
	supplierAttachmentId : string = '';
	fileName             : string = '';

	constructor(dto?: any) {

		super(dto);
		
		if (U.isEmpty(dto)) {
			return;
		}

		this.requestNumber        = dto.request_number;
		this.supplierAttachmentId = dto.supplier_attachment_id;
		this.fileName             = dto.file_name;
	}
	
	/**
	 * Ritorna il messaggio formattato
	 * 
	 * Al momento questa implementazione non supporta il multilanguage
	 * Bisognerebbe implementare una printf - guardare MessageManagerUtilities.getMessage() da esempio
	 * 
	 * @returns {string}
	 */
	getMessage(): string {
		// error → Request ('%d') - ('NEG%d') error occurred during handling attachment: ('%s') - ('%s')
		return `Richiesta ${this.externalRequestId} - ${this.requestNumber} Errore durante la gestione dell'allegato: ${this.supplierAttachmentId} - ${this.fileName}`;
		// return this.message;
	}
}
